export const ISSUE_DETAIL_URL = '/issue/detailJson';
